import { FunctionComponent, useEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./InstructionPending.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { pendingExam } from "../../Redux/Slices/PendingExam/PendingExamSlice";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { addOpenSection } from "../../Redux/Slices/OpenSection/AddOpenSectionSlice";
import {
  AppBar,
  Box,
  Button,
  Card,
  CardContent,
  CssBaseline,
  Grid,
  SvgIcon,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AppBarnav from "../../Components/AppBar/AppBar";
import { ReactComponent as Logo } from "../../Assets/Images/loginlogo.svg";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

interface InstructionPendingProps {}

const InstructionPending: FunctionComponent<InstructionPendingProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  const { state: exam_id } = useLocation();

  const { data: listexamlist, isLoading: listexamlistLoading } = useAppSelector(
    (state) => state.PendingExamSlice
  );
  const InstructionPendinglist: any = listexamlist?.data;
  const dispatch = useAppDispatch();

  const finalInstructionPending = InstructionPendinglist?.exam_instructions;

  const [details, setDetails] = useState<ILoginResponse>({});

  useEffect(() => {
    dispatch(pendingExam({ id: exam_id }));
  }, []);

  useEffect(() => {
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);
  const handleButtonClick = () => {
    // dispatch(
    //   addStudentExam({
    //     exam_id: InstructionPendinglist?.exam_id,
    //     student_id: details?.id,
    //     closed: false,
    //     questions: InstructionPendinglist?.questions,
    //   })
    // );
    sessionStorage.setItem("student_id", details?.id);
    navigate("/pendingexam", {
      state: { examID: exam_id },
    }); // Replace with your target route
    dispatch(
      addOpenSection({
        student_exam_id: exam_id,
        remaining_time: null,
        closed: false,
        question_type_id:
          InstructionPendinglist?.questions_by_type[0]?.question_type_id,
      })
    );
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // question count
  const totalQuestionCount = InstructionPendinglist?.questions_by_type?.reduce(
    (sum: any, item: any) => sum + item.question_count,
    0
  );
  return (
    <>
      <Box sx={{ display: "flex", height: "1px" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "#FFFFFF",
            display: "flex",
            boxShadow: "0px 4px 40px 0px #0000000D",
          }}
        >
          <Toolbar
            sx={{
              minHeight: "0px",
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "0px",
              paddingRight: "0px",
              margin: "0% 8%",
              height: "50px",
            }}
          >
            <Typography variant="h6" noWrap component="div">
              <SvgIcon
                sx={{
                  width: "123px",
                  height: "50px",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
                color="primary"
                component={Logo}
                inheritViewBox
              />
            </Typography>
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  color: "#009dff",
                  fontSize: "16px",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate("/dashboard"); // Replace with your target route
                }}
              >
                <ArrowBackIosIcon sx={{ color: "#009dff" }} />
                <div style={{ color: "#009dff", fontSize: "15px" }}>
                  {" "}
                  Back To Dashboard
                </div>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{ flexGrow: 1, height: "100vh", width: "100%" }}
        >
          <Outlet />
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "50px",
          backgroundColor: "#f5f9ff",
          minHeight: "100vh",
          py: 5,
          px: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <Grid container spacing={4} justifyContent="center" maxWidth="lg">
          <Grid item xs={12}>
            <Typography
              variant="h3"
              fontWeight="bold"
              textAlign="center"
              color="#1e3a8a"
            >
              {InstructionPendinglist?.exam_name}
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              maxWidth="700px"
              mx="auto"
              fontSize="19px"
              mt={1}
              color="#4b5563"
            >
              {InstructionPendinglist?.exam_description}
            </Typography>
          </Grid>

          {/* Instructions Card */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                p: 2,
                borderRadius: "12px",
                boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    color: "#111827",
                    fontSize: "1.7rem",
                    marginBottom: "15px",
                  }}
                >
                  Please Read Instructions Carefully
                </Typography>

                <Box mb={2}>
                  {finalInstructionPending?.map((item: any, index: any) => (
                    <Typography variant="body1" key={index} gutterBottom>
                      {/* <div key={index} className="instructionitem"> */}

                      <div
                        style={{
                          fontSize: "18px",
                          marginBottom: "20px",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span
                          style={{
                            height: "20px",
                            // width: "20px",
                            backgroundColor: "#009dff",
                            color: "#374151",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "9px",
                            // marginRight: "8px",
                          }}
                        >
                          <span
                            style={{
                              height: "4px",
                              width: "4px",
                              backgroundColor: "#ffffff",
                              borderRadius: "50%",
                              display: "inline-block",
                            }}
                          />
                        </span>

                        {item?.instruction}
                      </div>
                    </Typography>
                  ))}
                </Box>

                <Box
                  display="flex"
                  gap={2}
                  flexDirection={isMobile ? "column" : "row"}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "17px",
                      backgroundColor:
                        listexamlist?.status === false ? "gray" : "#009DFF",
                      cursor:
                        listexamlist?.status === false
                          ? "not-allowed"
                          : "pointer",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#009dff",
                      },
                    }}
                    onClick={handleButtonClick}
                  >
                    Resume Test
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "17px",
                      backgroundColor: "white",
                      color: "#009dff",
                      borderColor: "#009dff",
                      "&:hover": {
                        borderColor: "#009dff",

                        backgroundColor: "white",
                        color: "#009dff",
                      },
                    }}
                    onClick={() => {
                      navigate("/dashboard"); // Replace with your target route
                    }}
                  >
                    Back To Home
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Test Includes Card */}
          <Grid item xs={12} md={3}>
            <Card
              sx={{
                // p: 2,
                borderRadius: "12px",
                backgroundColor: "#f5faff",
                boxShadow: "0px 37px 37px rgba(0, 157, 255, 0.1)",
                border: "1px solid #e0f0ff",
              }}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ color: "#111827", fontSize: "1.7rem" }}
                >
                  Exam Includes
                </Typography>

                {InstructionPendinglist?.questions_by_type?.map((item: any) => (
                  <Box
                    key={item.question_type_id}
                    sx={{
                      p: 2,
                      borderRadius: "10px",
                      backgroundColor: "white",
                      mb: 2,
                      border: "1px solid #dceeff",
                    }}
                  >
                    <Typography sx={{ fontWeight: "bold", fontSize: "1.3rem" }}>
                      {item.question_type_name}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        Question type:
                      </span>
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {item.question_type_name === "Writing"
                          ? "Written"
                          : "MCQ"}
                      </div>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        Question count:
                      </span>
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {item.question_count}
                      </div>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "1.3rem",
                        alignItems: "center",
                      }}
                    >
                      <span style={{ color: "#4B5563", fontSize: "1.3rem" }}>
                        Duration:
                      </span>
                      <div style={{ fontWeight: 500, color: "black" }}>
                        {item.duration}
                      </div>
                    </Typography>
                  </Box>
                ))}

                <Box
                  sx={{
                    borderTop: "1px solid #e0e0e0",
                    pt: 2,
                    display: "flex",
                    justifyContent: "space-around",
                    flexWrap: "wrap",
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        {" "}
                        <AccessTimeIcon
                          sx={{ color: "#009DFF", fontSize: "3rem" }}
                        />
                      </div>
                      <Typography
                        variant="caption"
                        sx={{ color: "#666", fontSize: "1rem" }}
                      >
                        TOTAL DURATION
                      </Typography>
                      <Typography
                        fontWeight="bold"
                        variant="body2"
                        sx={{ fontSize: "1.2rem" }}
                      >
                        {InstructionPendinglist?.total_timing}
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <TaskAltIcon
                          sx={{ color: "#009DFF", fontSize: "3rem" }}
                        />
                      </div>

                      <Typography
                        variant="caption"
                        sx={{ color: "#666", fontSize: "1rem" }}
                      >
                        QUESTIONS
                      </Typography>
                      <Typography
                        fontWeight="bold"
                        variant="body2"
                        sx={{ fontSize: "1.2rem" }}
                      >
                        {totalQuestionCount ?? "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default InstructionPending;
